<app-header>
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
</app-header>
<mat-toolbar class="app-toolbar" color="primary"> </mat-toolbar>
<div class="main-content">
  <div *ngIf="showLoading$ | async" class="loading cf-flex-row cf-justify-content-center">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>
  <div *ngIf="(showLoading$ | async) === false">
    <div *ngIf="userSettingsEntity$ | async as userSettingsEntity" class="cf-flex-row cf-justify-content-center">
      <app-user-settings-form [userSettingsEntity]="userSettingsEntity" [messages]="messages"></app-user-settings-form>
    </div>
  </div>
</div>
